var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgH4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.78 29.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-H4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.39,17.27c-2.49.37-3.52,2.38-4,4.63a16.59,16.59,0,0,0-.36,4,3.5,3.5,0,0,0,1.51,2.87c1.19.79,2.35.63,3.7.63h8.7a19.48,19.48,0,0,0,4.21-.17c2.75-.83,2.67-3.7,2.34-6-.3-2.08-1-4.67-3.12-5.6-2.91-1.27-2.5,1.17-6.4,1.62A7,7,0,0,1,6,17.71c-.75-.48-.71-.58-1.64-.44Z",
    transform: "translate(0 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64,7A5.31,5.31,0,0,0,6,8.94a5.64,5.64,0,0,0,.74,7.94A5.37,5.37,0,0,0,11,18.14,5.62,5.62,0,1,0,9.64,7Z",
    transform: "translate(0 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.14,7.85a4.93,4.93,0,0,0,0-1.4l1.51-1.18a.38.38,0,0,0,.09-.46L32.3,2.34A.33.33,0,0,0,32,2.16l-.12,0-1.78.72a5,5,0,0,0-1.21-.7L28.61.3a.35.35,0,0,0-.35-.3H25.4a.35.35,0,0,0-.35.3l-.27,1.9a5.38,5.38,0,0,0-1.21.7l-1.78-.72-.13,0a.37.37,0,0,0-.31.18L19.92,4.81a.36.36,0,0,0,.09.46l1.5,1.18a5.36,5.36,0,0,0-.05.7,5.49,5.49,0,0,0,.05.7L20,9a.37.37,0,0,0-.09.46L21.35,12a.33.33,0,0,0,.31.18l.13,0,1.78-.72a5,5,0,0,0,1.21.7l.27,1.9a.35.35,0,0,0,.35.3h2.86a.35.35,0,0,0,.35-.3l.27-1.9a5.38,5.38,0,0,0,1.21-.7l1.78.72.13,0a.35.35,0,0,0,.3-.18l1.44-2.47A.37.37,0,0,0,33.65,9L32.14,7.85ZM30.72,6.63a3.66,3.66,0,0,1,0,.52c0,.15,0,.31,0,.52l-.1.81.64.5.77.6-.5.87-.91-.37-.74-.3-.65.48a4,4,0,0,1-.89.53l-.76.3-.11.81-.14,1h-1l-.14-1-.12-.81-.75-.3a4.11,4.11,0,0,1-.88-.51l-.65-.5-.76.31-.91.36-.5-.86.77-.6.64-.5-.1-.81c0-.22,0-.39,0-.53s0-.31,0-.52l.1-.81-.64-.5-.77-.6.5-.87.91.37.74.3L24.41,4a4.71,4.71,0,0,1,.9-.52l.76-.31.11-.8.15-1h1l.14,1,.11.8.76.31a4.37,4.37,0,0,1,.88.51l.65.5.76-.31.91-.36.5.86-.77.61-.64.5.11.81ZM26.83,4.29a2.86,2.86,0,1,0,2.85,2.86A2.86,2.86,0,0,0,26.83,4.29Zm0,4.29a1.43,1.43,0,1,1,1.43-1.43A1.43,1.43,0,0,1,26.83,8.58Z",
    transform: "translate(0 0)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.86,28.91l-4.53-3.34c-.81-.6-.5-1.34-.5-2.22l5,3.72,5-3.72c0,1.18.37,1.57-.71,2.37Z",
    transform: "translate(0 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.19,16.37V26.58l.67.49.67-.49V16.52A9.81,9.81,0,0,1,26.19,16.37Z",
    transform: "translate(0 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgH4);
export default __webpack_public_path__ + "static/media/H4.b7951e1c5a136d43240d583d8b2d77e1.svg";
export { ForwardRef as ReactComponent };